<template>
    <md-menu :class="['cunstom-tree-select','col-12','p-0',{ 'md-disabled': disabled }]" :md-close-on-select="false" :md-active.sync="showSelect" :md-offset-x="offset.x" :md-offset-y="offset.y" :md-dense="mdDense" @md-closed="onClose">

        <custom-chips
                v-if="showChips"
                ref="chips"
                @click.native="openSelect"
                :select-data="CustomTreeSelect.selectedItemlist"
                :chips-input-disabled="inputDisabled"
                :chips-input-name="inputName"
                chips-input-readonly
                :show-value-text="showValueText"
                :item-value-text="itemValueText"
                :item-text="itemText"
                :item-key="itemKey"
                :input-default-string="inputDefaultString"
                v-on:remove-chip="onRemoveChip"/>

        <custom-label-input
                v-if="!showChips"
                ref="labelInput"
                @click.native="openSelect"
                :value="CustomTreeSelect.value[0]"
                :label="CustomTreeSelect.label ? CustomTreeSelect.label : inputDefaultString"
                :name="inputName"
                :input-default-string="inputDefaultString"/>

        <keep-alive>
            <custom-menu-content ref="menu" class="md-select-menu" :md-content-class="mdClass" :style="menuStyles" @enter="onMenuEnter">
                <custom-tree-view
                        ref="treeViewComp"
                        :open-all="openAll"
                        :value="CustomTreeSelect.value"
                        :open="CustomTreeSelect.open"
                        :items="CustomTreeSelect.items"
                        :old-nodes="CustomTreeSelect.oldNodes"
                        :multiple="multiple"
                        :selection-mode="selectionMode"
                        :show-value-text="showValueText"
                        :item-value-text="itemValueText"
                        :item-text="itemText"
                        :item-key="itemKey"
                        :selection-type="selectionType"
                        :select-all="selectAll"
                        v-on:emit-selected="onSelectionChange"/>
            </custom-menu-content>
        </keep-alive>

    </md-menu>
</template>

<script>
    import raf from 'raf'
    import MdComponent from '../../core/MdComponent'
    import MdDropDownIcon from '../../core/icons/MdDropDownIcon'
    import MdMenu from '../../components/MdMenu/MdMenu'
    import MdMenuContent from '../../components/MdMenu/MdMenuContent'
    import MdInput from '../../components/MdField/MdInput/MdInput'
    import MdFieldMixin from '../../components/MdField/MdFieldMixin'
    import MdField from "../../components/MdField/MdField";
    import CustomChips from "./CustomChips";
    import MdOption from "../../components/MdField/MdSelect/MdOption";
    import CustomTreeView from "./CustomTreeView";
    import CustomMenuContent from "../Common/CustomMenuContent";
    import CustomLabelInput from "./CustomLabelInput";

    const defaultOffset = {
        x: 0,
        y: 70
    };

    export default {
        name: "CustomTreeSelect",
        components: {
            CustomLabelInput,
            MdInput,
            MdMenu,
            MdField,
            MdFieldMixin,
            MdDropDownIcon,
            CustomChips,
            MdOption,
            CustomTreeView,
            CustomMenuContent
        },
        mixins: [MdFieldMixin],
        props: {
            mdDense: Boolean,
            mdClass: String,
            multiple:  {
                type: Boolean,
                default: false,
            },
            multipleCollectText:  {
                type: Boolean,
                default: true,
            },
            multipleCollectTextCount:  {
                type: Number,
                default: 1,
            },
            multipleCollectTextMassage:  {
                type: String,
                default: '件　選択しています',
            },
            open: {
                type: Array,
                default: () => ([]),
            },
            openAll: {
                type: Boolean,
                default: true,
            },
            id: String,
            name: String,
            items: Array,
            itemKey: {
                type: String,
                default: 'id',
            },
            itemValueText: {
                type: String,
                default: 'value',
            },
            itemText: {
                type: String,
                default: 'name',
            },
            itemChildren: {
                type: String,
                default: 'children',
            },
            value: {
                type: [Array, String],
                default: () => ([]),
            },
            selectedItems: {
                type: Array,
                default: () => ([]),
            },
            inputDisabled: {
                type: Boolean,
                default: false,
            },
            inputName: {
                type: String,
                default: 'customTreeSelected'
            },
            inputReadonly: {
                type: Boolean,
                default: false,
            },
            inputDefaultString: {
                type: String,
                default: '未選択'
            },
            selectionMode:{
                type: String,
                default: 'deepest'
            },
            showValueText:{
                type: Boolean,
                default: false,
            },
            showChips:{
                type: Boolean,
                default: false,
            },
            selectionType: {
                type: String,
                default: 'leaf',
                validator: (v) => ['leaf', 'independent'].includes(v),
            },
            selectAll: {
                type: Boolean,
                default: true,
            }
        },
        inject: {
            MdField: {
                default: () => MdField
            }
        },
        data() {
            return {
                menuStyles: {},
                offset: {
                    x: defaultOffset.x,
                    y: 0
                },
                showSelect: true,
                didMount: false,
                CustomTreeSelect: {
                    items: this.items,
                    label: null,
                    multiple: false,
                    multipleText: false,
                    modelValue: this.localValue,
                    setValue: this.setValue,
                    setContent: this.setContent,
                    setMultipleValue: this.setMultipleValue,
                    setMultipleContent: this.setMultipleContent,
                    selectedItemlist: this.selectedItems,
                    value: Array.isArray(this.value) ? this.value : [this.value],
                    open: Array.isArray(this.open) ? this.open : [this.open],
                    oldNodes:{},
                },

            }
        },
        provide() {
            return {
                treeselect: this.CustomTreeSelect
            }
        },
        computed: {
            attrs() {
                return {
                    ...this.$attrs,
                    name: this.name,
                    id: undefined
                }
            },
            inputListeners() {
                return {
                    ...this.$listeners,
                    input: undefined
                }
            },
            dataValue() {
                return this.CustomTreeSelect.value;
            },
        },
        watch: {
            localValue: {
                immediate: true,
                handler(val) {
                    this.setFieldContent();
                    this.CustomTreeSelect.modelValue = this.localValue;

                    if (this.didMount) {
                        this.emitSelected(val);
                    }
                }
            },
            multiple: {
                immediate: true,
                handler(isMultiple) {
                    this.CustomTreeSelect.multiple = isMultiple;
                    this.$nextTick(this.initialLocalValueByDefault);
                }
            },
            selectedItems: {
                immediate: true,
                handler(items) {
                    this.selectedItems = items;
                    this.$nextTick();
                }
            },
            dataValue:{
                immediate: true,
                handler(value) {
                    this.localValue = this.CustomTreeSelect.value;
                    this.$nextTick(function () {
                        let tmpValue;
                        if (!Array.isArray(value)) {
                            tmpValue = [value];
                        } else {
                            tmpValue = value;
                        }

                        this.CustomTreeSelect.selectedItemlist = [];

                        let ___this = this;
                        let selectedItems = [];
                        tmpValue.forEach((selectKey) => {
                            let selecteditem = ___this.getItems(___this.CustomTreeSelect.items, selectKey);
                            if (selecteditem.length > 0) {
                                let obj = {};
                                obj[___this.itemKey] = selecteditem[0][___this.itemKey];
                                obj[___this.itemText] = selecteditem[0][___this.itemText];
                                obj[___this.itemValueText] = selecteditem[0][___this.itemValueText];
                                selectedItems.push(obj);
                            }
                        });

                        this.CustomTreeSelect.selectedItemlist = selectedItems;

                        if (this.showChips) {
                            if (this.$refs.chips) {
                                Vue.set(this.$refs.chips, 'value', this.CustomTreeSelect.selectedItemlist);
                            }
                        } else {
                            if (this.$refs.labelInput) {
                                if (this.CustomTreeSelect.selectedItemlist.length > 0) {
                                    this.setFieldContent();
                                    Vue.set(this.$refs.labelInput, 'labelData', this.CustomTreeSelect.label);
                                    Vue.set(this.$refs.labelInput, 'valueData', this.CustomTreeSelect.value.join(','));
                                } else {
                                    Vue.set(this.$refs.labelInput, 'labelData', "");
                                    Vue.set(this.$refs.labelInput, 'valueData', "");
                                }
                            }
                        }
                    });
                }
            }
        },
        methods: {
            elHasScroll(el) {
                return el.scrollHeight > el.offsetHeight
            },
            scrollToSelectedOption(el, menu) {
                const top = el.offsetTop;
                const elHeight = el.offsetHeight;
                const menuHeight = menu.offsetHeight;

                menu.scrollTop = top - ((menuHeight - elHeight) / 2)
            },
            setOffsets(target) {
                if (!this.$isServer) {
                    const menu = this.$refs.menu.$refs.container;

                    if (menu) {
                        const selected = target || menu.querySelector('.md-selected');

                        if (selected) {
                            this.scrollToSelectedOption(selected, menu);
                            this.offset.y = defaultOffset.y - selected.offsetTop + menu.scrollTop + 8;
                            this.menuStyles = {
                                'transform-origin': `0 ${Math.abs(this.offset.y)}px`
                            }
                        } else {
                            this.offset.y = defaultOffset.y + 1;
                            this.menuStyles = {}
                        }
                    }
                }
            },
            onMenuEnter() {
                if (!this.didMount) {
                    return
                }

                this.setOffsets();
                this.MdField.focused = true;
                this.$emit('md-opened')
            },
            applyHighlight() {
                this.MdField.focused = false;
                this.MdField.highlighted = true;
                this.$refs.input.$el.focus()
            },
            onClose() {
                this.$emit('md-closed');
                if (this.didMount) {
                    this.applyHighlight()
                }
            },
            onFocus() {
                if (this.didMount) {
                    this.applyHighlight()
                }
            },
            removeHighlight() {
                this.MdField.highlighted = false
            },
            openSelect() {
                if (!this.disabled) {
                    this.showSelect = true
                }
            },
            arrayAccessorRemove(arr, index) {
                let before = arr.slice(0, index);
                let after = arr.slice(index + 1, arr.length);
                return before.concat(after)
            },
            toggleArrayValue(value) {
                let index = this.localValue.indexOf(value);
                let includes = index > -1;
                if (!includes) {
                    this.localValue = this.localValue.concat([value])
                } else {
                    this.localValue = this.arrayAccessorRemove(this.localValue, index)
                }
            },
            setValue(newValue) {
                this.model = newValue;
                this.setFieldValue();
                this.showSelect = false
            },
            setContent(newLabel) {
                this.CustomTreeSelect.label = newLabel
            },
            setContentByValue() {
                const textContent = this.getItem(this.CustomTreeSelect.items,Array.isArray(this.localValue) ? this.localValue[0] : this.localValue);

                let temptextContent;
                if( typeof textContent === 'object' && textContent !== null ){
                    if(this.showValueText){
                        temptextContent = (textContent[this.itemValueText] ? textContent[this.itemValueText] : '') + ' : ' +
                            (textContent[this.itemText] ? textContent[this.itemText] : '');
                    }else {
                        temptextContent = (textContent[this.itemText] ? textContent[this.itemText] : '');
                    }
                }else{
                    temptextContent = textContent;
                }

                if (temptextContent) {
                    this.setContent(temptextContent)
                } else {
                    this.setContent('')
                }
            },
            setMultipleValue(value) {
                const newValue = value;
                this.toggleArrayValue(newValue);
                this.setFieldValue()
            },
            setMultipleContentByValue() {
                if (!this.localValue) {
                    this.initialLocalValueByDefault()
                }

                let content = [];

                this.localValue.forEach(item => {
                    const textContent = this.getItem(this.CustomTreeSelect.items,item);
                    let temptextContent;
                    if( typeof textContent === 'object' && textContent !== null ){
                        if(this.showValueText){
                            temptextContent = (textContent[this.itemValueText] ? textContent[this.itemValueText] : '') + ' : ' +
                                (textContent[this.itemText] ? textContent[this.itemText] : '');
                        }else {
                            temptextContent = (textContent[this.itemText] ? textContent[this.itemText] : '');
                        }
                    }else{
                        temptextContent = textContent;
                    }
                    if (temptextContent) {
                        content.push(temptextContent)
                    }
                });
                if(this.multipleCollectText && content.length > this.multipleCollectTextCount){
                    this.setContent(content.length + this.multipleCollectTextMassage);
                }else{
                    this.setContent(content.join(', '));
                }
            },
            setFieldContent() {
                if (this.multiple) {
                    this.setMultipleContentByValue()
                } else {
                    this.setContentByValue()
                }
            },
            isLocalValueSet() {
                return this.localValue !== undefined && this.localValue !== null
            },
            setLocalValueIfMultiple() {
                if (this.isLocalValueSet()) {
                    this.localValue = [this.localValue];
                } else {
                    this.localValue = [];
                }
            },
            setLocalValueIfNotMultiple() {
                if (this.localValue.length > 0) {
                    this.localValue = this.localValue[0];
                } else {
                    this.localValue = null;
                }
            },
            initialLocalValueByDefault() {
                let isArray = Array.isArray(this.localValue);

                if (this.multiple && !isArray) {
                    this.setLocalValueIfMultiple();
                } else if (!this.multiple && isArray) {
                    this.setLocalValueIfNotMultiple();
                }
            },
            emitSelected(value) {
                this.$emit('md-selected', value)
            },
            onSelectionChange(selected, nodes) {
                this.CustomTreeSelect.value = [];
                this.CustomTreeSelect.value = Array.from(selected.values());
                this.$emit('on-selection-change', this.CustomTreeSelect.value);
            },
            onRemoveChip(chip, index) {
                let idx = this.CustomTreeSelect.value.findIndex(val => val === chip[this.itemKey]);
                if (idx > -1) {
                    this.CustomTreeSelect.value.splice(idx, 1);
                }
                this.CustomTreeSelect.oldNodes[chip[this.itemKey]].isSelected = false;
                let descendant = this.getDescendants(chip[this.itemKey]);
                descendant.forEach(key => {
                    let idx = this.CustomTreeSelect.value.findIndex(val => val === key);
                    if (idx > -1) {
                        this.CustomTreeSelect.value.splice(idx, 1);
                    }
                    this.CustomTreeSelect.oldNodes[key].isSelected = false;
                });
                const parents = this.getParents(chip[this.itemKey]);
                parents.forEach(parent => {
                    let calc = this.calculateState(this.CustomTreeSelect.oldNodes[parent], this.CustomTreeSelect.oldNodes);
                    if (!calc.isSelected) {
                        let idx = this.CustomTreeSelect.value.findIndex(val => val === parent);
                        if (idx > -1) {
                            this.CustomTreeSelect.value.splice(idx, 1);
                        }
                    }
                });
                this.$emit('on-remove-chip', this.CustomTreeSelect.value);
            },
            getItems(items, key) {
                let retItems = [];
                for (let i = 0; i < items.length; i++) {
                    const itemKey = this.getObjectValueByPath(items[i], this.itemKey);
                    if (itemKey === key) {
                        retItems.push(items[i]);
                    }
                    const children = this.getObjectValueByPath(items[i], this.itemChildren);
                    if (children) {
                        retItems.push(...this.getItems(children, key));
                    }
                }
                return retItems;
            },
            getItem(items, key) {
                let retItems = null;
                for (let i = 0; i < items.length; i++) {
                    const itemKey = this.getObjectValueByPath(items[i], this.itemKey);
                    if (itemKey === key) {
                        retItems = items[i];
                    }
                    const children = this.getObjectValueByPath(items[i], this.itemChildren);
                    if (children) {
                        let childitem =  this.getItem(children, key);
                        if(childitem){
                            retItems = childitem;
                        }
                    }
                }
                return retItems;
            },
            getObjectValueByPath(obj, path, fallback = {}) {
                if (obj == null || !path || typeof path !== 'string') return fallback;
                if (obj[path] !== undefined) return obj[path];
                path = path.replace(/\[(\w+)\]/g, '.$1');
                path = path.replace(/^\./, '');
                return this.getNestedValue(obj, path.split('.'), fallback)
            },
            getNestedValue(obj, path, fallback = {}) {
                const last = path.length - 1;
                if (last < 0) return obj === undefined ? fallback : obj;
                for (let i = 0; i < last; i++) {
                    if (obj == null) {
                        return fallback;
                    }
                    obj = obj[path[i]];
                }
                if (obj == null) return fallback;

                return obj[path[last]] === undefined ? fallback : obj[path[last]];
            },
            getDescendants(key, descendants = []) {
                const children = this.CustomTreeSelect.oldNodes[key].children;

                descendants.push(...children);

                for (let i = 0; i < children.length; i++) {
                    descendants = this.getDescendants(children[i], descendants);
                }
                return descendants;
            },
            getParents(key) {
                let parent = this.CustomTreeSelect.oldNodes[key].parent;

                const parents = [];
                while (parent != null) {
                    parents.push(parent);
                    parent = this.CustomTreeSelect.oldNodes[parent].parent;
                }

                return parents;
            },
            calculateState(node, state) {
                const counts = node.children.reduce((counts, child) => {
                    counts[0] += +Boolean(state[child].isSelected);
                    counts[1] += +Boolean(state[child].isIndeterminate);
                    return counts;
                }, [0, 0]);

                node.isSelected = !!node.children.length && counts[0] === node.children.length;
                node.isIndeterminate = !node.isSelected && (counts[0] > 0 || counts[1] > 0);

                return node
            },
            log(msg, obj = "") {
                console.log(msg, obj);
            }
        },
        mounted() {
            this.showSelect = false;
            this.setOffsets();
        },
        created() {
            if(this.CustomTreeSelect.open.length === 0){
                this.CustomTreeSelect.open = this.CustomTreeSelect.value;
            }
            if(this.multipleCollectText){
                this.setFieldContent();
            }
            // this.localValue = this.value;
        },
        updated() {
        }

    }
</script>

<style lang="scss">
    @import "../../components/MdAnimation/variables";

    .md-menu-content {
        max-width: 90vw;
    }

    .md-menu.md-select {
        display: flex;
        flex: 1;
        overflow: auto;

        &:not(.md-disabled) {
            .md-input,
            .md-icon {
                cursor: pointer;
                outline: none;
            }
        }

        .md-input {
            flex: 1;
            min-width: 0;
        }

        select,
        .md-input-fake {
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            overflow: hidden;
            position: absolute;
            clip: rect(0 0 0 0);
            border: 0;
        }
    }

    .md-menu-content.md-select-menu {
        z-index: 1050;
        width: initial;
        padding: 1rem;
        background-color: white;

        &.md-menu-content-enter {
            transform: translate3d(0, -8px, 0) scaleY(.3);
        }

        ul.md-list {
            transition: opacity .3s $md-transition-drop-timing;
            margin: 0;
            padding: 0;
        }
    }

</style>
